package ai.beakman.undercover.i18n

/** `window.navigator.language` sem dependência do kotlinx-browser. */
private external val navigator: Navigator

private external interface Navigator {
    val language: String?
}

actual fun detectSystemLanguage(): Language =
    Language.fromCode(
        try {
            navigator.language
        } catch (_: Throwable) {
            null
        },
    )
